import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import alertSlice from '../reducers/alertSlice'
import sessionSlice from '../reducers/sessionSlice';
import translateSlice from '../reducers/translateSlice';
import socketSlice from 'src/reducers/socketSlice';


const reducers = combineReducers({
  alert: alertSlice,
  session: sessionSlice,
  translate: translateSlice,
  socket: socketSlice
});

const persistConfig = {
  key: 'root',
  storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
});

const persistor = persistStore(store);

export { persistor };
export default store;